module.exports = __webpack_public_path__ + "img/Kitutu-Marion.92e55ffe.jpg";